import React, { useState } from 'react';
import { ShoppingCart, X, Trash2, Plus, Minus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import './Cart.css';
import { useCart } from '../context/CartContext';

const Cart = ({ onCheckout, onClose }) => {
  const { cartItems, addToCart, removeFromCart, clearCart, getCartTotal, getCartCount } = useCart();
  const navigate = useNavigate();

  const cartCount = getCartCount();
  const cartTotal = getCartTotal();

  const handleCheckout = () => {
    onClose();
    navigate('/checkout');
  };

  return (
    <>
      {/* Cart Drawer */}
      <div className="cart-overlay" onClick={onClose} />
      <div className="cart-drawer">
        <div className="cart-header">
          <h3 className="cart-title">Your Cart</h3>
          <button className="cart-close" onClick={onClose}>
            <X size={24} />
          </button>
        </div>

            <div className="cart-content">
              {cartItems.length === 0 ? (
                <div className="cart-empty">
                  <ShoppingCart size={48} className="empty-icon" />
                  <p>Your cart is empty</p>
                  <p className="empty-text">Add microgreens varieties to get started!</p>
                </div>
              ) : (
                <>
                  <div className="cart-items">
                    {cartItems.map((item) => (
                      <div key={item.id} className="cart-item">
                        <img src={item.image} alt={item.name} className="cart-item-image" />
                        <div className="cart-item-details">
                          <h4 className="cart-item-name">{item.name}</h4>
                          <p className="cart-item-price">₹{item.price} each</p>
                          <div className="cart-item-quantity-controls">
                            <button 
                              className="qty-btn qty-decrease"
                              onClick={() => removeFromCart(item.id)}
                              aria-label="Decrease quantity"
                            >
                              <Minus size={16} />
                            </button>
                            <span className="qty-value">{item.quantity}</span>
                            <button 
                              className="qty-btn qty-increase"
                              onClick={() => addToCart(item)}
                              aria-label="Increase quantity"
                            >
                              <Plus size={16} />
                            </button>
                          </div>
                        </div>
                        <div className="cart-item-actions">
                          <span className="cart-item-total">₹{item.price * item.quantity}</span>
                          <button 
                            className="cart-item-remove"
                            onClick={() => {
                              // Remove all quantities of this item
                              for (let i = 0; i < item.quantity; i++) {
                                removeFromCart(item.id);
                              }
                            }}
                            aria-label="Remove item completely"
                            title="Remove from cart"
                          >
                            <Trash2 size={16} />
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="cart-footer">
                    <div className="cart-total">
                      <span>Total:</span>
                      <span className="cart-total-amount">₹{cartTotal}</span>
                    </div>
                    <button className="btn-secondary" onClick={clearCart}>
                      Clear Cart
                    </button>
                    <button className="btn-primary" onClick={handleCheckout}>
                      Proceed to Checkout
                    </button>
                  </div>
                </>
              )}
            </div>
      </div>
    </>
  );
};

export default Cart;
